import {Pagination} from './pagination';

/**
 * @ignore
 * @internal
 * */
export class ApiResponse {
  status = true;
  message = '';
  result: any = null;
  pagination: Pagination = null;

  constructor(options: Partial<ApiResponse> = null) {
    Object.assign(this, options);
  }
}
